<base-site-layout
  [heading]="'Bedarfsmeldung durch PDF-Upload erzeugen' | translate"
  headerIcon="fas fa-file-upload"
  [isDialog]="true"
  (dialogCloseClicked)="close()"
  >
  @if (isUploading()) {
    <div class="row">
      <div class="col">
        <div class="alert alert-info" role="alert" data-testid="pdf-upload-analyzing">
          <em class="fas fa-spinner fa-spin me-2"></em>
          {{ 'PDF wird analysiert – das kann bis zu einer Minute dauern.' | translate }}
        </div>
      </div>
    </div>
  } @else if (analysisRunning()) {
    <div class="row">
      <div class="col">
        <div class="alert alert-warning" role="alert">
          <em class="fas fa-exclamation-triangle me-2"></em>
          {{ 'Es läuft bereits eine Analyse. Eine neue Analyse überschreibt die aktuell laufende Analyse.' | translate }}
        </div>
      </div>
    </div>
  }
  @if (draftExists()) {
    <div class="row">
      <div class="col">
        <div class="alert alert-warning" role="alert">
          <em class="fas fa-exclamation-triangle me-2"></em>
          {{ 'Es existiert bereits ein Bedarfsmeldungs-Entwurf. Die Analyse einer neuen Bedarfsmeldung überschreibt den aktuellen Entwurf.' | translate }}
        </div>
      </div>
    </div>
  }
  <div class="row">
    <div class="col">
      <div class="alert alert-info" role="alert">
        <em class="fas fa-info-circle me-2"></em>
        {{ 'Die Analyse legt lediglich einen Entwurf an und reicht die Bedarfsmeldung noch nicht zur Genehmigung ein.' | translate }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <ngx-dropzone
        class="pdf-dropzone w-100"
        [accept]="'application/pdf'"
        [multiple]="false"
        [disabled]="isUploading()"
        (change)="onPdfDropped($event)"
        >
        <ngx-dropzone-label class="text-center">
          <div class="dropzone-label-content">
            <em class="fas fa-file-pdf me-2"></em>
            <span>{{ 'Hier eine PDF ablegen' | translate }}</span>
            <div class="text-muted small mt-2">
              {{ 'oder klicken um auszuwählen' | translate }}
            </div>
          </div>
        </ngx-dropzone-label>
        @if (droppedFile()) {
          <ngx-dropzone-preview
            class="upload-preview"
            [removable]="true"
            (removed)="removeDroppedFile()"
            [title]="droppedFile()?.name"
            >
            <ngx-dropzone-label>
              {{ droppedFile()?.name }} ({{ droppedFile()?.size | fileSize }})
            </ngx-dropzone-label>
          </ngx-dropzone-preview>
        }
      </ngx-dropzone>
      @if (uploadError()) {
        <div class="alert alert-danger mt-3" role="alert">
          {{ uploadError() | translate }}
        </div>
      }
    </div>
  </div>
  <div class="row mt-4 align-items-end">
    <div class="col d-flex flex-column">
      @if (companyCodesLoading()) {
        <div class="alert alert-info mb-0" role="alert" data-testid="pdf-upload-company-code-loading">
          <em class="fas fa-spinner fa-spin me-2"></em>
          {{ 'Buchungskreise werden geladen …' | translate }}
        </div>
      } @else if (showCompanyCodeSelect()) {
        <label for="pdf-upload-company-code">{{ 'Buchungskreis' | translate }}</label>
        <select
          id="pdf-upload-company-code"
          class="form-select"
          data-testid="pdf-upload-company-code-select"
          [disabled]="isUploading()"
          (change)="onCompanyCodeSelected($event)"
          >
          <option value="" disabled [selected]="!selectedCompanyCodeId()">
            {{ 'Bitte wählen Sie einen Buchungskreis aus' | translate }}
          </option>
          @for (companyCode of sortedCompanyCodes(); track companyCode.id) {
            <option [value]="companyCode.id" [selected]="companyCode.id === selectedCompanyCodeId()">
              {{ companyCode.code }} - {{ companyCode.name }}
            </option>
          }
        </select>
      } @else if (companyCodesError()) {
        <div class="alert alert-warning mb-0" role="alert" data-testid="pdf-upload-company-code-error">
          <em class="fas fa-exclamation-triangle me-2"></em>
          {{ 'Fehler beim Laden der Buchungskreise' | translate }}
          {{ 'Bitte versuchen Sie, die Seite zu aktualisieren.' | translate }}
        </div>
      }
    </div>
    <div class="col-auto">
      <button class="btn btn-outline-dark" (click)="close()">
        {{ 'Abbrechen' | translate }}
      </button>
    </div>
    <div class="col-auto">
      <button
        class="btn btn-primary"
        data-testid="pdf-upload-start-button"
        (click)="uploadPdf()"
        [disabled]="uploadDisabled()"
        >
        @if (isUploading()) {
          <em class="fas fa-spinner fa-spin me-2"></em>
        } @else {
          <em class="fas fa-file-upload me-2"></em>
        }
        {{ 'Upload starten' | translate }}
      </button>
    </div>
  </div>
</base-site-layout>
